import { positions as positionsConstants } from "../_constants/positions.constants";

const initialState = {
    data: [],
    loading: false,
    error: '',
}

export function positions(state = initialState, action) {
    switch (action.type) {
        case positionsConstants.GET_POSITIONS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case positionsConstants.GET_POSITIONS_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            }
        case positionsConstants.GET_POSITIONS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        default:
            return state;
    }
}
